import { SystemField } from "./system-field";

export class LoginHistory extends SystemField{ 
     login_time?:string;
     platform?:string;
     login_url?:string;
     location?:string;
     source_ip?:string;
     reason?:string;
     username?:string;
     is_success?:number;
}
